module.exports = __webpack_public_path__ + "img/red_001.8a088d2f.png";